import { useFragment } from "react-relay";
import { showAnswerButtonContainer_NodeFragment$key } from "@generated/showAnswerButtonContainer_NodeFragment.graphql";
import { SHOW_ANSWER_CONTAINER_FRAGMENT } from "./show-answer-button-container.graphql";
import { Container } from "./show-answer-button-container.styles";
import { ShowAnswerButtonContainerProps } from "./show-answer-button-container.types";
import { ShowAnswersButton } from "../../../learning/show-answer-button";

export const ShowAnswerButtonContainer = ({
	learnOpportunityFragmentRef,
	hasMultipleChoice,
	disabled,
	isContentSubmissionScreen,
}: ShowAnswerButtonContainerProps) => {
	const learnOpportunity = useFragment<showAnswerButtonContainer_NodeFragment$key>(
		SHOW_ANSWER_CONTAINER_FRAGMENT,
		learnOpportunityFragmentRef,
	)!;

	return (
		<Container className="w-full text-center">
			{learnOpportunity.typeDefinition.children
				? learnOpportunity.typeDefinition.children
						?.filter(
							(c) =>
								c.typeDefinition.containedElementTypes?.filter((e) => e.includes("multipleChoice"))
									.length,
						)
						.map((ch) => (
							<div key={ch.id}>
								<ShowAnswersButton
									isContentSubmissionScreen={isContentSubmissionScreen}
									disabled={disabled}
									learnOpportunityFragmentRef={ch}
								/>
							</div>
						))
				: hasMultipleChoice && (
						<ShowAnswersButton
							isContentSubmissionScreen={isContentSubmissionScreen}
							learnOpportunityFragmentRef={learnOpportunity}
						/>
					)}
		</Container>
	);
};
